export function pluralizeString(string: string, count: number): string {
  let pluralizedString = '';
  if (string) {
    let s = count === 1 ? '' : 's';
    if (string.endsWith('y')) {
      s = count === 1 ? 'y' : 'ies';
      string = string.slice(0, -1);
    }
    if (string.endsWith('s')) {
      s = count === 1 ? '' : 'es';
    }
    pluralizedString = `${string}${s}`;
  }
  return pluralizedString;
}
